import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

const client = axios.create({
    baseURL: API_BASE,
    timeout: 15000,
});

export const api = {
    health: () => client.get("/health").then((r) => r.data),
    katlasStatus: () => client.get("/katlas/status").then((r) => r.data),
    katlasDiagnostics: () =>
        client.get("/katlas/diagnostics", { params: { probe: "full" } }).then((r) => r.data),
    listReferrals: () => client.get("/referrals").then((r) => r.data),
    getReferral: (id) => client.get(`/referrals/${id}`).then((r) => r.data),
    requestClarification: (id, body) =>
        client.post(`/referrals/${id}/clarification`, body).then((r) => r.data),
    submitEvidence: (id, body) =>
        client.post(`/referrals/${id}/evidence`, body).then((r) => r.data),
    submitDecision: (id, body) =>
        client.post(`/referrals/${id}/decision`, body).then((r) => r.data),
    submitAppetiteFeedback: (id, body) =>
        client.post(`/referrals/${id}/appetite-feedback`, body).then((r) => r.data),
    publicReceipt: (hash) =>
        client.get(`/receipts/${encodeURIComponent(hash)}/public`).then((r) => r.data),
    verifyReceipt: (hash) =>
        client.post(`/receipts/${encodeURIComponent(hash)}/verify`).then((r) => r.data),
};
